<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          text
        >
          Logout
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">
          Are you sure you want to Logout?
        </v-card-title>
        <v-card-text>Any unsaved data will not be lost unless app closes.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="ok"
          >
            OK
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'vLogoutModal',
    data () {
      return {
        dialog: false,
      }
    },
    methods: {
      ok () {
        this.$emit('ok')
        this.dialog = false
      },
    },
  }
</script>
